import { useCallback } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FeatureThemeProvider } from '../../../theme/FeatureThemeProvider';
import { navigateToRoute } from '../../../utils/navigation/resolveActiveRoute';
import DashboardWelcomeHeader from '../components/DashboardWelcomeHeader';
import QuickLinkGrid from '../components/QuickLinkGrid';
import RecentActivitySection from '../components/RecentActivitySection';
import useDashboardHubSx from '../hooks/useDashboardHubSx';
import useQuickLinks from '../hooks/useQuickLinks';

function DashboardHubPageContent() {
  const styles = useDashboardHubSx();
  const navigate = useNavigate();
  const { quickLinks, isLoading } = useQuickLinks();

  const handleOpenLink = useCallback(
    (route) => {
      navigateToRoute(route, navigate);
    },
    [navigate]
  );

  return (
    <Box sx={styles.pageRoot}>
      <DashboardWelcomeHeader styles={styles} />

      <QuickLinkGrid
        links={quickLinks}
        isLoading={isLoading}
        styles={styles}
        onOpenLink={handleOpenLink}
      />

      {/* <RecentActivitySection styles={styles} /> */}
    </Box>
  );
}

export default function DashboardHubPage() {
  return (
    <FeatureThemeProvider>
      <DashboardHubPageContent />
    </FeatureThemeProvider>
  );
}
